import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function CancelledPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const hasCanceledFlag = searchParams.get('canceled') === 'true';

  React.useEffect(() => {
    if (sessionId || hasCanceledFlag) {
      navigate(`/${window.location.search}`, { replace: true });
    }
  }, [navigate, sessionId, hasCanceledFlag]);

  const redirectHref = `/${typeof window !== 'undefined' ? window.location.search : ''}`;

  return (
    <>
      <Helmet>
        <title>Returning to Checkout | Decisive Sites</title>
        <meta name="description" content="Redirecting back to checkout to resume your session" />
      </Helmet>
      <section>
        <p>Redirecting you back to checkout… If nothing happens, <a href={redirectHref}>click here</a>.</p>
      </section>
    </>
  );
}
